<template>
    <section>
        <Breadcrumbs main="Services" title="Lifestyle" />
        <div v-if="routeName != 'lifestyle'">
			<comingSoon/>
		</div>
        <section v-else>
        <section class="banner-wrapper container">
            <div class="card shadow-lg">
                <div class="card-body">
                    <div class="text-center">
                        <p class="welcome-text">Welcome to</p>
                        <h4>TAJBank Lifestyle</h4>
                        <div class="icon-section mt-5 d-flex justify-content-center">
                            <div>
                                <i class="fa fa-university"></i>
                                <p class="live">Live!</p>
                            </div>
                            <div class="icon-wrapper">
                                <i class="fa fa-thumbs-up"></i>
                                <p>Enjoy!</p>
                            </div>
                            <div class="icon-wrapper">
                                <i class="fa fa-globe"></i>
                                <p>Experience!</p>
                            </div>
                            <div class="icon-wrapper">
                                <i class="fa fa-shopping-bag"></i>
                                <p>Shop!</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="lifestyle-image-wrapper container">
            <div class="row">
            <div class="col-md-3 lifestyle-card">
                <router-link to="/lifestyle/flight">
                    <img src="@/assets/TAJimages/travel.png" class="img-fluid">
                    <h4 class="lifestyle-text">Travel</h4>
                </router-link>
            </div>
            <div class="col-md-3 lifestyle-card">
                <router-link to="/lifestyle/hotel">
                    <img src="@/assets/TAJimages/hotels/hotel-bg.png" class="img-fluid">
                    <h4 class="lifestyle-text">Hotels</h4>
                </router-link>
            </div>
            <div class="col-md-3 lifestyle-card">
                <img src="@/assets/TAJimages/events.png" class="img-fluid">
                <h4 class="lifestyle-text">Events</h4>
            </div>
            <div class="col-md-3 lifestyle-card">
                <img src="@/assets/TAJimages/tajmall.png" class="img-fluid">
                <h4 class="lifestyle-text">Taj Mall</h4>
            </div>
            </div>
        </section>
        </section>
    </section>
</template>
<script>
  import comingSoon from '@/components/coming-soon.vue';
  export default {
    components: {
      comingSoon
    },
    data:() => ({
    }),
    computed: {
      routeName() {
        return this.$route.name;
      },
    },
    mounted() {
    },
  };
</script>
<style scoped>
.comingsoon {
    min-height: 70vh !important;
}
.card {
    background-image: url(/assets/TAJimages/life_bg.png);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}
.fa-university {
    font-size: 25px;
    color: #E41617;
    background: #FFF4F2;
    width: 70px;
    padding: 20px;
    border-radius: 15px;
}
.fa-thumbs-up {
    font-size: 25px;
    color: #4CD4AB;
    background: #E6F9F1;
    padding: 20px;
    width: 70px;
    border-radius: 15px;
}
.fa-globe {
    font-size: 25px;
    color: #878CFB;
    background: #F2F2FF;
    width: 70px;
    padding: 20px;
    border-radius: 15px;
}
.fa-shopping-bag {
    font-size: 25px;
    color: #FFAF4E;
    background: #FFF1E0;
    width: 70px;
    padding: 20px;
    border-radius: 15px;
}
.icon-wrapper {
    margin-left: 45px;
}
.icon-wrapper p, .live {
    font-weight: 600;
    margin-top: 10px;
    font-family: 'Open Sans', sans-serif;
}
.welcome-text {
    color: #9B9AAC;
    font-size: 19px;
}
.lifestyle-text {
  position: absolute;
  bottom: 10px;
  left: 40px;
  font-size: 21px;
  font-weight: 400;
  color: #fff;
}
.lifestyle-card img {
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  height: 215px;
  border-radius: 15px;
}
.lifestyle-card img:last-child {
    width: 250px;
}
.lifestyle-card img:hover {
  box-shadow: 3px 18px 67px -27px rgba(0,0,0,0.63);
  -webkit-box-shadow: 3px 18px 67px -27px rgba(0,0,0,0.63);
  -moz-box-shadow: 3px 18px 67px -27px rgba(0,0,0,0.63);
}
.lifestyle-image-wrapper {
    /* margin: 50px 0 70px 0; */
}
@media screen and (max-width: 768px) {
  .lifestyle-card img {
    height: 100%;
    margin-top: 10px;
  }
  .lifestyle-card {
    margin-top: 30px;
  }
  .icon-wrapper {
    margin-left: 20px;
  }
}
</style>